import React, { memo, useMemo } from 'react';
import { DemeterDataFrequency, DemeterDataSource, DemeterSymbolModel } from '../../../../Generated/Raven-Demeter';
import BarChartRaw from '../../../Components/Charts/Bar/BarChartRaw';
import { IChartDataSeries } from '../../../Components/Charts/ChartDefinitions';
import ChartWrapper from '../../../Components/Charts/ChartWrapper/ChartWrapper';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import { MonthlyRiskCompositeModel, RiskRequest } from '../RiskDefinitions';

export interface ICumulativeValueAtRisk {
    symbol: DemeterSymbolModel;
    risksRequest: RiskRequest;
    calculatedRisks: MonthlyRiskCompositeModel[];
    track: TrackingEvent;
}

const CumulativeValueAtRiskChart: React.FC<ICumulativeValueAtRisk> = (props: ICumulativeValueAtRisk) => {
    const [translations] = useLanguage();

    const barSeries = useMemo<IChartDataSeries[]>(
        () => [
            {
                label: translations.risk.headers.cumulativeValueAtRisk,
                data: props.calculatedRisks.map((x) => ({
                    value: x.riskCumulative ?? 0,
                    asOfDate: new Date(x.dataYear, x.dataMonth, 1),
                    isActualValue: true,
                })),
            },
        ],
        [props.calculatedRisks],
    );

    return (
        <ChartWrapper
            name="CumulativeValueAtRiskChart"
            title={translations.risk.headers.cumulativeValueAtRisk}
            dataSourceTag={[translations.exchange[props.symbol.exchange], translations.dataSource[DemeterDataSource.StoneXCalculations]]}
            isLoading={props.calculatedRisks.length === 0}
            track={props.track}
        >
            <BarChartRaw barSeries={barSeries} currency={props.risksRequest.currency} format="currency" dataFrequency={DemeterDataFrequency.Monthly} />
        </ChartWrapper>
    );
};

export default memo(CumulativeValueAtRiskChart);
